import { render, staticRenderFns } from "./ResultDetailSacrificeInLeft.vue?vue&type=template&id=1ca75686&scoped=true&"
import script from "./ResultDetailSacrificeInLeft.vue?vue&type=script&lang=js&"
export * from "./ResultDetailSacrificeInLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca75686",
  null
  
)

export default component.exports